// Central configuration. The Giphy API key is kept from the original app.
export const GIPHY_API_KEY = 'FJj8POCZ4gSBtik9E546BCkk98fSnJ7d';

export const GIPHY_SEARCH_URL = 'https://api.giphy.com/v1/gifs/search';
export const GIPHY_TRENDING_URL = 'https://api.giphy.com/v1/gifs/trending';

/** How many GIFs to fetch per page / "load more". */
export const RESULT_LIMIT = 12;

/** Quick-button animals seeded on first visit. */
export const DEFAULT_ANIMALS = ['Lion', 'Tiger', 'Monkey', 'Otter', 'Panda'];

/** Allowed Giphy content ratings. */
export const RATINGS = ['g', 'pg', 'pg-13', 'r'] as const;
export type Rating = (typeof RATINGS)[number];
export const DEFAULT_RATING: Rating = 'pg';

/** How many recent search terms to remember. */
export const MAX_HISTORY = 8;

// localStorage keys.
export const STORAGE_KEYS = {
  animals: 'giftastic:animals',
  favorites: 'giftastic:favorites',
  history: 'giftastic:history',
  theme: 'giftastic:theme',
  rating: 'giftastic:rating',
} as const;
